import { notFound } from '@tanstack/react-router';

// Permitting ids in the address. Parsing never throws (a thrown parse shows the error
// page); the route's loader calls assertIds, and anything that isn't a positive whole
// number shows the app's not-found page instead.
export const toId = (value: string) => Number(value);

export const assertIds = (...ids: number[]) => {
  if (ids.some((id) => !Number.isInteger(id) || id < 1)) throw notFound();
};
